<template>
    <!-- Template for add merchant (manual) -->
    <v-row style="user-select: none" class="py-8 px-5 px-md-10">
        <v-col md="3">
            <v-card class="pa-4">
                <div class="pa-4" v-if="action == 'edit'">
                    <v-img aspect-ratio="1" :src="`data:image/png;base64,${formDetails.qr_base64}`" alt="QR Code"></v-img>
                </div>
                <v-img v-else :src="require('../../assets/img/qr-placeholder.svg')" class="my-3" contain aspect-ratio="1" />
                <h2 class="text-center">{{ formDetails.name }}</h2>
                <p class="font-weight-light text-center">{{ formDetails.mobile | formatMobileNumber }}</p>
                <div class="mt-8">
                    <v-btn color="primary" class="mb-3 disabled" block depressed>
                        <v-icon left>mdi-email-outline</v-icon>
                        Send QR
                    </v-btn>
                    <v-menu transition="slide-y-transition" bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn color="fiord" class="mb-3 white--text disabled" v-bind="attrs" v-on="on" block depressed>
                                <v-icon left>mdi-tray-arrow-down</v-icon>
                                Download QR
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item>
                                <v-list-item-title>Download {{ oldClassification == 'BRANCH' ? 'Branch' : 'Partner' }} QR only</v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-title>Download Partner &amp; Branches QR</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                    <v-btn color="fiord" class="mb-3 white--text disabled" block depressed>
                        <v-icon left>mdi-printer</v-icon>
                        Print QR
                    </v-btn>
                </div>
            </v-card>
        </v-col>
        <v-col md="9" class="pl-md-8 form-data">
            <h2 class="mb-10">{{ (action == 'edit' && oldClassification == 'BRANCH') || this.$route.path.includes('branch') ? 'Branch' : 'Merchant' }} Information</h2>
            <v-row>
                <v-col cols="12" md="6" class="py-0">
                    <label for="store_name" class="font-weight-medium">{{ oldClassification == 'BRANCH' ? 'Branch' : 'Merchant' }} Name</label>
                    <v-text-field
                        :value="formDetails.name"
                        id="store_name"
                        :class="['mt-3', { 'is-invalid': errors.name }]"
                        :error-messages="errors.name"
                        @change="updateStore($event, 'name')"
                        solo
                        dense
                        :rules="[$validate.rules.nameRequired(formDetails.name, 'name')]"
                        :validate-on-blur="true"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                    <label for="mobile_number" class="font-weight-medium">Mobile Number</label>
                    <v-text-field
                        :value="formDetails.mobile"
                        id="mobile_number"
                        :class="['mt-3', { 'is-invalid': errors.mobile }]"
                        :error-messages="errors.mobile"
                        @keypress="$validate.numbersOnly"
                        @change="updateStore($event, 'mobile')"
                        solo
                        dense
                        :rules="[$validate.rules.nameRequired(formDetails.mobile, 'mobile', false, false, true)]"
                        :validate-on-blur="true"
                    ></v-text-field>
                </v-col>

                <v-col md="12" class="py-0">
                    <label class="font-weight-medium">Merchant Address</label>
                    <v-text-field
                        :value="formDetails.address"
                        id="street_addr"
                        label="Street Address"
                        :class="['mt-3', { 'is-invalid': errors.address }]"
                        :error-messages="errors.address"
                        @change="updateStore($event, 'address')"
                        solo
                        dense
                        :rules="[$validate.rules.nameRequired(formDetails.address, 'address')]"
                        :validate-on-blur="true"
                    ></v-text-field>
                </v-col>
                <!-- <v-col md="12"><v-text-field id="street_addr" label="Street Address" solo dense></v-text-field></v-col> -->
                <v-col cols="12" md="6" class="py-0">
                    <v-text-field
                        :value="formDetails.municipality"
                        id="municipality"
                        label="Municipality"
                        :class="['mt-3', { 'is-invalid': errors.municipality }]"
                        :error-messages="errors.municipality"
                        @change="updateStore($event, 'municipality')"
                        solo
                        dense
                        :rules="[$validate.rules.nameRequired(formDetails.municipality, 'municipality')]"
                        :validate-on-blur="true"
                    ></v-text-field>

                    <!-- <v-select
                        :value="formDetails.municipality"
                        id="city_addr"
                        :loading="loadState.municipality"
                        :items="formSelectItems.municipality"
                        label="Municipality / City"
                        :class="{ 'is-invalid': errors.municipality }"
                        :error-messages="errors.municipality"
                        @change="updateStore($event, 'municipality')"
                        solo
                        dense
                        :rules="[$validate.rules.nameRequired(formDetails.municipality, 'municipality')]"
                        :validate-on-blur="true"
                    ></v-select> -->
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                    <v-text-field
                        :value="formDetails.province"
                        id="province_addr"
                        label="Province"
                        :class="['mt-3', { 'is-invalid': errors.province }]"
                        :error-messages="errors.province"
                        @change="updateStore($event, 'province')"
                        solo
                        dense
                        :rules="[$validate.rules.nameRequired(formDetails.province, 'province')]"
                        :validate-on-blur="true"
                    ></v-text-field>
                    <!-- <v-select
                        :value="formDetails.province"
                        id="province_addr"
                        :loading="loadState.province"
                        :items="formSelectItems.province"
                        label="Province"
                        :class="{ 'is-invalid': errors.province }"
                        :error-messages="errors.province"
                        @change="updateStore($event, 'province')"
                        solo
                        dense
                        :rules="[$validate.rules.nameRequired(formDetails.province, 'province')]"
                        :validate-on-blur="true"
                    ></v-select> -->
                </v-col>

                <v-col cols="12" md="6" class="py-0">
                    <label class="font-weight-medium">Location</label>
                    <v-text-field
                        :value="formDetails.location"
                        id="location"
                        :class="['mt-3', { 'is-invalid': errors.location }]"
                        :error-messages="errors.location"
                        @change="updateStore($event, 'location')"
                        solo
                        dense
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                    <label class="font-weight-medium">
                        Minimum Points Required
                        <v-tooltip bottom max-width="300px">
                            <template v-slot:activator="{ on }">
                                <v-icon class="ml-2" v-on="on" small>mdi-alert-circle-outline</v-icon>
                            </template>

                            <div class="tooltip-wrapper">
                                <span>Minimum points required to avail the rewards or promotion.</span>
                            </div>
                        </v-tooltip>
                    </label>
                    <v-text-field
                        :value="formDetails.min_points"
                        id="points"
                        type="number"
                        :class="['mt-3', { 'is-invalid': errors.min_points }]"
                        :error-messages="errors.min_points"
                        @change="updateStore($event, 'min_points')"
                        @keydown="$validate.minPoints"
                        @paste.prevent
                        :min="1"
                        solo
                        dense
                        :rules="[$validate.rules.nameRequired(formDetails.min_points, 'min points')]"
                        :validate-on-blur="true"
                    ></v-text-field>
                </v-col>

                <v-col cols="12" md="6" class="py-0">
                    <label class="font-weight-medium">Type</label>
                    <v-text-field
                        :value="formDetails.type"
                        id="type"
                        type="text"
                        :class="['mt-3', { 'is-invalid': errors.type }]"
                        :error-messages="errors.type"
                        @change="updateStore($event, 'type')"
                        solo
                        dense
                    ></v-text-field>
                    <!-- <v-select :value="formDetails.type" id="type" :items="typeMenuItems" label="Select type..." class="mt-3" @change="updateStore($event, 'type')" solo dense></v-select> -->
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                    <label class="font-weight-medium">Classification</label>
                    <v-select
                        :value="formDetails.classification"
                        id="classification"
                        :disabled="isDisabledClassification"
                        :loading="loadState.classification"
                        :items="formSelectItems.classification"
                        label="Select classification..."
                        :class="['mt-3', { 'is-invalid': errors.classification, disabled: isDisabledClassification }]"
                        :error-messages="errors.classification"
                        @change="onClassificationChange($event)"
                        solo
                        dense
                    ></v-select>
                </v-col>

                <v-col cols="12" md="6" class="py-0">
                    <label class="font-weight-medium">Longitude</label>
                    <v-text-field
                        :value="formDetails.longitude"
                        id="longitude"
                        :class="['mt-3', { 'is-invalid': errors.longitude }]"
                        :error-messages="errors.longitude"
                        @change="updateStore($event, 'longitude')"
                        solo
                        dense
                        :rules="[$validate.rules.nameRequired(formDetails.longitude, 'longitude')]"
                        :validate-on-blur="true"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                    <label class="font-weight-medium">Latitude</label>
                    <v-text-field
                        :value="formDetails.latitude"
                        id="latitude"
                        :class="['mt-3', { 'is-invalid': errors.latitude }]"
                        :error-messages="errors.latitude"
                        @change="updateStore($event, 'latitude')"
                        solo
                        dense
                        :rules="[$validate.rules.nameRequired(formDetails.latitude, 'latitude')]"
                        :validate-on-blur="true"
                    ></v-text-field>
                </v-col>

                <v-col cols="12" md="6" class="py-0">
                    <label class="font-weight-medium">Batch Number</label>
                    <v-text-field :value="formDetails.batch_number" id="batch_number" :class="['mt-3', { 'is-invalid': errors.batch_number }]" :error-messages="errors.batch_number" solo dense disabled></v-text-field>
                </v-col>

                <v-col cols="12" md="6" class="py-0">
                    <label class="font-weight-medium">Partner</label>
                    <v-select
                        :value="formDetails.partner"
                        id="partner"
                        :disabled="disablePartner"
                        :loading="loadState.partner"
                        :items="formSelectItems.partner"
                        label="Select partner..."
                        :class="['mt-3', { 'is-invalid': errors.partner }, { disabled: disablePartner }]"
                        :error-messages="errors.partner"
                        @change="updateStore($event, 'partner')"
                        solo
                        dense
                        :rules="[$validate.rules.nameRequired(formDetails.partner, 'partner')]"
                        :validate-on-blur="true"
                    ></v-select>
                </v-col>

                <!-- <v-col md="6"
                    ><label class="font-weight-medium">Primary Merchant (if Branch) </label>
                    <v-select
                        :value="formDetails.primary_merchant_id"
                        id="primary_merchant"
                        :loading="loadState.merchant"
                        item-text="text"
                        item-value="value"
                        :items="formSelectItems.merchant"
                        label="Select merchant..."
                        :class="['mt-3', { 'is-invalid': errors.primary_merchant_id }, { disabled: disablePrimaryMerchant }]"
                        :error-messages="errors.primary_merchant_id"
                        @change="onPrimaryMerchantChange($event)"
                        return-object
                        :menu-props="{ maxHeight: 200 }"
                        solo
                        dense
                    >
                    </v-select>
                </v-col> -->

                <template v-if="showSettings">
                    <!-- Activation Setting -->
                    <v-col cols="12" lg="12">
                        <div class="pa-3 white rounded-lg">
                            <v-row align="center" justify="center" class="text-center">
                                <v-col cols="12" md="4"><p class="mb-0 text-left font-weight-bold">Activation Setting</p></v-col>
                                <v-col cols="12" md="8">
                                    <div class="pa-1 rounded" style="background-color: #e7edf0">
                                        <v-row align="center" justify="center">
                                            <v-col>
                                                <div class="font-weight-bold cursor-pointer text-caption text-md-body-2" :class="activateImmediatelyClass" @click="toggleSetting('activate', 'immediate')">
                                                    Activate Immediately
                                                </div>
                                            </v-col>
                                            <v-col>
                                                <div class="font-weight-bold cursor-pointer text-caption text-md-body-2" :class="activateScheduledClass" @click="toggleSetting('activate', 'scheduled')">
                                                    Schedule Activation
                                                </div>
                                            </v-col>
                                        </v-row>
                                    </div>
                                </v-col>
                            </v-row>
                            <!-- Additional Settings -->
                            <transition name="scroll-y-transition">
                                <v-row v-if="activation === 'scheduled'">
                                    <v-col sm="6" class="py-0">
                                        <!-- @TODO possible component -->
                                        <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" :return-value.sync="formDetails.activate_at" transition="scale-transition" offset-y min-width="auto">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    class="py-3"
                                                    label="Date of Activation"
                                                    v-model="formDetails.activate_at"
                                                    append-icon="mdi-calendar"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    v-on:click:append="menu1 = true"
                                                    solo
                                                    :rules="[$validate.rules.nameRequired(formDetails.activate_at, 'BY_DATE', true)]"
                                                    :validate-on-blur="true"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker v-model="formDetails.activate_at" :min="minDate" :class="{ 'is-invalid': errors.activate_at }" :error-messages="errors.activate_at" no-title scrollable>
                                                <v-spacer></v-spacer>
                                                <v-btn text color="primary" @click="menu1 = false">Cancel</v-btn>
                                                <v-btn text color="primary" @click="saveActivation('menu1', 'activate_at', formDetails.activate_at)">OK</v-btn>
                                            </v-date-picker>
                                        </v-menu>
                                    </v-col>
                                </v-row>
                            </transition>
                        </div>
                    </v-col>

                    <!-- Deactivation Setting -->
                    <v-col cols="12" lg="12">
                        <div class="pa-3 white rounded-lg">
                            <v-row align="center" justify="center" class="text-center">
                                <v-col cols="12" md="4"><p class="mb-0 text-left font-weight-bold">Deactivation Setting</p></v-col>
                                <v-col md="8">
                                    <div class="pa-1 rounded" style="background-color: #e7edf0">
                                        <v-row align="center" justify="center">
                                            <v-col>
                                                <div class="font-weight-bold cursor-pointer text-caption text-md-body-2" :class="deactivateManuallyClass" @click="toggleSetting('deactivate', 'manual')">
                                                    Deactivate Manually
                                                </div>
                                            </v-col>
                                            <v-col>
                                                <div class="font-weight-bold cursor-pointer text-caption text-md-body-2" :class="deactivateScheduledClass" @click="toggleSetting('deactivate', 'scheduled')">
                                                    Schedule Deactivation
                                                </div>
                                            </v-col>
                                        </v-row>
                                    </div>
                                </v-col>
                            </v-row>

                            <!-- Additional Settings -->
                            <transition name="scroll-y-transition">
                                <v-row v-if="deactivation === 'scheduled'">
                                    <v-col class="py-0">
                                        <!-- @TODO possible component -->
                                        <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" :return-value.sync="formDetails.deactivate_at" transition="scale-transition" offset-y min-width="auto">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-row>
                                                    <v-col cols="12" class="py-0">
                                                        <v-radio-group :value="formDetails.deactivate_setting" @change="updateStore($event, 'deactivate_setting')" row>
                                                            <v-radio label="Specify Date" value="BY_DATE"></v-radio>
                                                            <v-radio v-if="activation === 'immediate'" label="Specify Duration" value="BY_DURATION"></v-radio>
                                                        </v-radio-group>
                                                    </v-col>
                                                    <!-- Text Field for DatePicker -->
                                                    <v-col cols="6" class="py-0">
                                                        <v-text-field
                                                            v-show="formDetails.deactivate_setting === 'BY_DATE'"
                                                            label="Date of Deactivation"
                                                            v-model="formDetails.deactivate_at"
                                                            append-icon="mdi-calendar"
                                                            :class="{ 'is-invalid': errors.deactivate_at }"
                                                            :error-messages="errors.deactivate_at"
                                                            readonly
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            v-on:click:append="menu2 = true"
                                                            solo
                                                            :rules="[$validate.rules.nameRequired(formDetails.deactivate_at, 'BY_DATE', true, 1)]"
                                                            :validate-on-blur="true"
                                                        ></v-text-field>
                                                    </v-col>
                                                </v-row>
                                                <!-- By Duration Setting -->
                                                <v-row v-show="formDetails.deactivate_setting === 'BY_DURATION'">
                                                    <v-col md="4"
                                                        ><v-text-field
                                                            id="duration"
                                                            type="number"
                                                            :value="formDetails.deactivate_duration"
                                                            :class="{ 'is-invalid': errors.deactivate_duration }"
                                                            :error-messages="errors.deactivate_duration"
                                                            @change="updateStore($event, 'deactivate_duration')"
                                                            solo
                                                            dense
                                                            min="1"
                                                            @paste="filterPasteAcceptPositive"
                                                        ></v-text-field
                                                    ></v-col>
                                                    <v-col md="4"
                                                        ><v-select
                                                            id="durationUnit"
                                                            :items="durationItems"
                                                            label="Select unit..."
                                                            :value="formDetails.deactivate_duration_unit"
                                                            :class="{ 'is-invalid': errors.deactivate_duration_unit }"
                                                            :error-messages="errors.deactivate_duration_unit"
                                                            @change="updateStore($event, 'deactivate_duration_unit')"
                                                            solo
                                                            dense
                                                        ></v-select
                                                    ></v-col>
                                                </v-row>
                                            </template>
                                            <v-date-picker v-model="formDetails.deactivate_at" :min="getMinDateByActivationDate" no-title scrollable>
                                                <v-spacer></v-spacer>
                                                <v-btn text color="primary" @click="menu2 = false">Cancel</v-btn>
                                                <v-btn text color="primary" @click="saveActivation('menu2', 'deactivate_at', formDetails.deactivate_at)">OK</v-btn>
                                            </v-date-picker>
                                        </v-menu>
                                    </v-col>
                                </v-row>
                            </transition>
                        </div>
                    </v-col>
                </template>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: 'QrForm',
    props: {
        //merchant or branch
        classification: String,
        //add or edit
        action: {
            type: String,
            required: true
        },
        customFilters: Object
    },
    data() {
        return {
            activation: 'immediate', //immediate | scheduled
            deactivation: 'manual', //manual | scheduled
            activeStyle: ['white', 'rounded', 'pa-1'],
            inactiveStyle: 'btn-inactive',
            menu1: false,
            menu2: false,
            loadState: {
                partner: true,
                classification: true,
                municipality: true,
                province: true,
                merchant: true
            },
            oldClassification: '',
            typeMenuItems: [
                {
                    text: 'VIP',
                    value: 'VIP'
                },
                {
                    text: 'Regular',
                    value: 'REGULAR'
                }
            ],
            durationItems: [
                {
                    text: 'Hours',
                    value: 'HOURS'
                },
                {
                    text: 'Days',
                    value: 'DAYS'
                },
                {
                    text: 'Months',
                    value: 'MONTHS'
                },
                {
                    text: 'Years',
                    value: 'YEARS'
                }
            ],
            disablePrimaryMerchant: false,
            minDate: this.$moment().add(1, 'd').format('YYYY-MM-DD')
        };
    },
    computed: {
        activateImmediatelyClass() {
            if (this.activation === 'immediate') {
                return this.activeStyle;
            }

            return this.inactiveStyle;
        },
        activateScheduledClass() {
            if (this.activation === 'scheduled') {
                return this.activeStyle;
            }

            return this.inactiveStyle;
        },
        deactivateManuallyClass() {
            if (this.deactivation === 'manual') {
                return this.activeStyle;
            }

            return this.inactiveStyle;
        },
        deactivateScheduledClass() {
            if (this.deactivation === 'scheduled') {
                return this.activeStyle;
            }

            return this.inactiveStyle;
        },
        isDisabledClassification() {
            return this.classification != '';
        },
        disablePartner() {
            return this.merchantPartner != '' || this.formDetails.classification == 'BRANCH';
        },
        filters() {
            const filters = {
                activationSetting: {
                    show: true,
                    disabled: true
                },
                deactivationSetting: {
                    show: true,
                    disabled: true
                }
            };

            return { ...filters, ...this.customFilters };
        },
        formDetails() {
            const newMerchantDetails = { ...this.$store.getters['merchants/getNewMerchantDetails'] };

            // Add default values
            const formatDate = (date) => {
                return this.$moment(date).format('YYYY-MM-DD');
            };

            if (newMerchantDetails.activate_at) {
                newMerchantDetails.activate_at = formatDate(newMerchantDetails.activate_at);
            }

            if (newMerchantDetails.deactivate_at) {
                newMerchantDetails.deactivate_at = formatDate(newMerchantDetails.deactivate_at);
            }

            if (!newMerchantDetails.batch_number) {
                newMerchantDetails.batch_number = 'N/A';
            }

            if (this.classification) {
                newMerchantDetails.classification = this.classification;
            }

            return { ...newMerchantDetails };
        },
        formSelectItems() {
            const data = {
                partner: this.formatFormItems(this.$store.getters['options/getPartners'], 'partner'),
                classification: this.formatFormItems(this.$store.getters['options/getMerchantClassifications'], 'classification')
                // municipality: this.formatFormItems(this.$store.getters['options/getMunicipalities']),
                // province: this.formatFormItems(this.$store.getters['options/getProvinces'])
                //merchant: this.$store.getters['options/getMerchants']
            };

            return data || {};
        },
        getMinDateByActivationDate() {
            if (this.activation === 'immediate') {
                let c = this.$moment();
                c = c.add(1, 'd').format('YYYY-MM-DD');
                return c;
            }

            if (!this.formDetails.activate_at) return this.minDate;
            let c = this.$moment(this.formDetails.activate_at);
            c = c.add(1, 'd').format('YYYY-MM-DD');
            return c;
        },

        merchantDetails() {
            return this.$store.getters['merchants/getMerchantDetails'];
        },
        merchantPartner() {
            // If logged in user is merchant, set default partner
            if (this.userInfo.role.id == 'MERCHANT' && this.userInfo.merchant && this.userInfo.merchant.partner) {
                return this.userInfo.merchant.partner;
            }
            // If logged in user is partner, set default partner by company
            else if (this.userInfo.role.id == 'PARTNER' && this.userInfo.company) {
                return this.userInfo.company;
            } else {
                if (this.formDetails.classification == 'BRANCH' || (this.formDetails.classification != 'PRIMARY' && this.$route.path.indexOf('merchants') > -1 && this.$route.path.indexOf('branches') > -1)) {
                    // If selected is branch, set default partner by its merchant
                    if (this.merchantDetails.primary_merchant && this.merchantDetails.primary_merchant.partner) {
                        return this.merchantDetails.primary_merchant.partner;
                    }
                    // If selected is branch, set default partner by its merchant
                    else if (this.merchantDetails && this.merchantDetails.partner) {
                        return this.merchantDetails.partner;
                    }
                }
            }

            return '';
        },
        showSettings() {
            return this.action != 'edit';
        }
    },

    watch: {
        '$store.state.merchants.newMerchantDetails.activate_setting': {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.activation = newVal;
                    this.updateStore(newVal, 'activate_setting');
                } else {
                    this.activation = 'immediate';
                    this.updateStore('immediate', 'activate_setting');
                }
            }
        },

        '$store.state.merchants.newMerchantDetails.deactivate_setting': {
            immediate: true,
            handler(newVal) {
                if (newVal === 'BY_DATE') {
                    this.deactivation = 'scheduled';
                    this.updateStore('', 'deactivate_duration_unit');
                    this.updateStore('', 'deactivate_duration');
                } else if (newVal === 'BY_DURATION') {
                    this.deactivation = 'scheduled';
                    this.updateStore('', 'deactivate_at');
                } else {
                    this.deactivation = 'manual';
                    this.updateStore('', 'deactivate_duration');
                    this.updateStore('', 'deactivate_duration_unit');
                    this.updateStore('', 'deactivate_at');
                }
            }
        },

        classification: {
            immediate: true,
            handler(value) {
                this.disablePrimaryMerchant = value != '';
            }
        },

        formDetails(value) {
            if (value) {
                if (value.classification == 'PRIMARY') {
                    this.disablePrimaryMerchant = true;
                }
            }
        }
    },
    created() {
        this.fetchFormItems();
        this.$store.commit('merchants/SET_MERCHANT_DETAILS', {});
        this.$store.commit('merchants/RESET_FORM');
        let id = this.$route.params.branch ? this.$route.params.branch : this.$route.params.id;

        if (id) {
            this.$store
                .dispatch('merchants/findMerchant', {
                    id: id,
                    action: this.action,
                    config: {
                        params: { appends: ['primary_merchant', 'qr_base64'] }
                    }
                })
                .then(() => {
                    this.oldClassification = this.formDetails.classification;
                    this.$emit('assignOldClassification', this.oldClassification);
                });
        }
    },
    beforeDestroy() {
        this.$store.commit('merchants/RESET_FORM');
    },
    methods: {
        fetchFormItems() {
            this.$store.dispatch('options/fetchPartners').then(() => (this.loadState.partner = !this.loadState.partner));
            this.$store.dispatch('options/fetchMerchantClassifications').then(() => (this.loadState.classification = !this.loadState.classification));
            // this.$store.dispatch('options/fetchMunicipalities').then(() => (this.loadState.municipality = !this.loadState.municipality));
            // this.$store.dispatch('options/fetchProvinces').then(() => (this.loadState.province = !this.loadState.province));
            // if (!this.disablePrimaryMerchant) {
            //     this.$store
            //         .dispatch('options/fetchMerchants', {
            //             config: {
            //                 params: {
            //                     'filter_classifications[]': 'PRIMARY',
            //                     sort_by: 'name',
            //                     order: 'asc'
            //                 }
            //             }
            //         })
            //         .then(() => (this.loadState.merchant = !this.loadState.merchant));
            // } else {
            //     this.loadState.merchant = false;
            // }
        },
        formatFormItems(formData, category) {
            let formatData = [];
            for (const [key, val] of Object.entries(formData)) {
                const obj = { text: key, value: val };

                if (category == 'partner' && this.merchantPartner && this.disablePartner) {
                    if (val == this.merchantPartner) {
                        formatData.push(obj);
                        this.formDetails.partner = val;
                        this.updateStore(this.formDetails.partner, 'partner');
                    } else {
                        formatData.push(obj);
                    }
                } else {
                    formatData.push(obj);
                }
            }

            if (category == 'classification' && this.classification) {
                this.updateStore(this.classification, 'classification');
            }

            return formatData;
        },
        onClassificationChange($event) {
            if ($event == 'PRIMARY') {
                this.disablePrimaryMerchant = true;
                this.onPrimaryMerchantChange({});
            } else {
                this.disablePrimaryMerchant = false;
                // Change partner value into current merchant's partner value
                this.updateStore(this.merchantDetails.partner, 'partner');
            }

            this.updateStore($event, 'classification');
        },
        onPrimaryMerchantChange($event) {
            this.updateStore($event.text, 'primary_merchant_name');
            this.updateStore($event.value, 'primary_merchant_id');
        },
        saveActivation(menu, key, value) {
            this.$refs[menu].save(value);
            // Remove deactivate_at value if menu is equal to menu1 (activate_at)
            if (menu == 'menu1') {
                this.formDetails.deactivate_at = '';
                this.updateStore('', 'deactivate_at');
            }
            this.updateStore(value, key);
        },
        setActivationState(state) {
            this.activation = state;
        },
        setDeactivationState(state) {
            this.deactivation = state;
        },
        toggleSetting(type, val) {
            switch (type) {
                case 'activate':
                    if (val === 'immediate') {
                        this.activation = 'immediate';
                        this.menu1 = false;
                        this.formDetails.activate_at = '';
                        this.updateStore('immediate', 'activate_setting');
                        this.updateStore('', 'activate_at');
                    } else {
                        this.activation = 'scheduled';
                        this.updateStore('scheduled', 'activate_setting');
                    }
                    break;
                case 'deactivate':
                    if (val === 'manual') {
                        this.deactivation = 'manual';
                        this.menu2 = false;
                        this.formDetails.deactivate_at = '';
                        this.formDetails.deactivate_duration = '';
                        this.formDetails.deactivate_duration_unit = '';
                        this.updateStore('MANUAL', 'deactivate_setting');
                    } else {
                        this.deactivation = 'scheduled';
                        this.formDetails.deactivate_setting = 'BY_DATE';
                        this.updateStore('BY_DATE', 'deactivate_setting');
                    }
                    break;
            }
        },
        updateStore(e, type) {
            this.$store.commit('merchants/SET_NEW_MERCHANT_DETAILS', { [type]: e });
        }
    }
};
</script>

<style>
.btn-inactive {
    color: #7c8a97;
}

.cursor-pointer {
    cursor: pointer;
}
</style>
